import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import { Typography, Box, Container, TextField, CssBaseline, Button, Avatar, Select, MenuItem, InputLabel, FormHelperText, FormControl, CircularProgress, Chip, Card, IconButton, Paper, Stack, useMediaQuery } from '@mui/material';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { connect } from "react-redux";
import { deleteUshers } from '../../app/store/actions/adminActions';
import { centered_flex_box, left_flex_box, right_flex_box, MainInput, MainInputLabel, MainPassword, main_button, reject_button, StyledInput, ter_button } from '../../app/components/Styles';
import { Form, useNavigate, useParams } from 'react-router-dom';
import ReactFileReader from 'react-file-reader';
import download from 'downloadjs';
import { notification } from 'antd';
import { deleteEvent, getEvent, getEventStatistics } from '../../app/store/actions/eventActions';
import { resendFailedInvitations, sendEventReminder, exportEventStatistics } from '../../app/store/actions/adminActions';
import { AddUsherModal, GenerateInvitationModal, GenerateTicketModal } from './components';
import LocationOn from '@mui/icons-material/LocationOn';
import AddShoppingCart from '@mui/icons-material/AddShoppingCart';
import moment from 'moment';
import Directions from '@mui/icons-material/Directions';
import SendIcon from '@mui/icons-material/Send';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InventoryIcon from '@mui/icons-material/Inventory';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie } from 'recharts';
import { getUshers } from '../../app/store/actions/adminActions';
import ActionDialog from '../../app/components/ActionDialog';
import { motion } from 'framer-motion';
import {
    PlatformPage,
    PlatformPageHeader,
    PlatformStatsGrid,
    PlatformStatCard,
    PlatformButton,
    PlatformActionSection,
    PlatformCard,
    PlatformAnalyticBar,
    PlatformLoadingBlock,
    PlatformTabs,
    computeEventDashboardStats,
} from '../../app/components/platform';
import {
    platformCardSx,
    platformColors,
    platformFonts,
    platformGhostButtonSx,
} from '../../app/components/tickitPlatformTheme';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import GroupsIcon from '@mui/icons-material/Groups';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const platformPaperSx = {
    ...platformCardSx,
    p: 3,
    color: 'var(--platform-text)',
    '& .MuiTypography-root': {
        fontFamily: platformFonts.body,
    },
    '& .MuiTypography-h4, & .MuiTypography-h5, & .MuiTypography-h6': {
        fontFamily: platformFonts.display,
        color: 'var(--platform-text)',
    },
};

const platformOutlinedBtnSx = { ...platformGhostButtonSx, borderWidth: 1.5 };

export const EventDashboard = ({ role, getEvent, getUshers, wait, statistics, event, ushers, isLoading, deleteEvent, deleteUshers, getEventStatistics, resendFailedInvitations, sendEventReminder, exportEventStatistics }) => {
    const navigate = useNavigate()
    const id = useParams().id
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const [action, setAction] = React.useState(false)
    const [deleteModal, setDeleteModal] = React.useState(false)
    const COLORS = ['var(--secColor)', 'var(--secColor2)', 'var(--terColor)', 'var(--terColor2)'];
    const actionButtonsWrapSx = {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        '& .MuiButton-root': {
            width: { xs: '100%', sm: 'auto' },
            justifyContent: 'center'
        }
    };

    function timeout(delay) {
        return new Promise(res => setTimeout(res, delay));
    }

    const [modals, setModals] = React.useState({
        generateTickets: false,
        generateInvitations: false,
        edit: false,
        addUsher: false,
    })

    const handleClose = (modalName) => {
        setModals({ ...modals, [modalName]: false })
    }

    const handleOpen = (modalName) => {
        setModals({ ...modals, [modalName]: true })
    }

    React.useEffect(() => {
        if (isMobile) {
            notification.info({ message: "Actions in this page may not render correctly on mobile phones", style: { marginTop: "10vh" } })
        }
        getEvent({ eventId: id });
        getEventStatistics({ eventId: id });
        getUshers({ eventId: id, page: 1, limit: 100 });
    }, [id, action])

    const handleRefresh = () => {
        getEvent({ eventId: id });
        getEventStatistics({ eventId: id });
        getUshers({ eventId: id, page: 1, limit: 100 });
    }

    const handleDeleteUsher = async (data) => {
        deleteUshers(data)
        await timeout(500)
        setAction(!action)
    }

    const dashStats = computeEventDashboardStats(event, statistics);

    const [statsTab, setStatsTab] = React.useState(0);

    if (isLoading) {
        return (
            <PlatformPage>
                <PlatformLoadingBlock minHeight="50vh" />
            </PlatformPage>
        )
    }

    return (
        <PlatformPage>
            <PlatformPageHeader
                title={event?.title || 'Event dashboard'}
                subtitle={[
                    event?.location,
                    event?.date ? moment(event.date).format('DD MMM YYYY · HH:mm') : null,
                ].filter(Boolean).join(' · ')}
            />

            {dashStats && (
                <PlatformStatsGrid>
                    {dashStats.mode === 'corporate' ? (
                        <>
                            <PlatformStatCard
                                label="Invitations sent"
                                value={dashStats.sent}
                                icon={<GroupsIcon />}
                                iconBg={platformColors.brandPale}
                                iconColor={platformColors.brand}
                            />
                            <PlatformStatCard
                                label="Confirmed"
                                value={dashStats.accepted}
                                delta={`${dashStats.confirmRate}% confirm rate`}
                                deltaTone="up"
                                icon={<HowToRegIcon />}
                                iconBg="#D1FAE5"
                                iconColor="#065F46"
                            />
                            <PlatformStatCard
                                label="Pending RSVP"
                                value={dashStats.pending}
                                icon={<PendingIcon />}
                                iconBg="#FEF3C7"
                                iconColor="#92400E"
                            />
                            <PlatformStatCard
                                label="Response rate"
                                value={`${dashStats.responseRate}%`}
                                delta={`${dashStats.rejected} declined`}
                                icon={<TrendingUpIcon />}
                                iconBg="#DBEAFE"
                                iconColor="#1E40AF"
                            />
                        </>
                    ) : (
                        <>
                            <PlatformStatCard
                                label="Tickets sold"
                                value={dashStats.sold}
                                icon={<ShoppingCartIcon />}
                                iconBg={platformColors.brandPale}
                                iconColor={platformColors.brand}
                            />
                            <PlatformStatCard
                                label="Remaining"
                                value={dashStats.remaining}
                                icon={<InventoryIcon />}
                                iconBg="#FEF3C7"
                                iconColor="#92400E"
                            />
                            <PlatformStatCard
                                label="Capacity"
                                value={dashStats.total}
                                icon={<EventAvailableIcon />}
                                iconBg="#DBEAFE"
                                iconColor="#1E40AF"
                            />
                            <PlatformStatCard
                                label="Sell-through"
                                value={`${dashStats.sellThrough}%`}
                                delta="Of available inventory"
                                deltaTone="up"
                                icon={<TrendingUpIcon />}
                                iconBg="#D1FAE5"
                                iconColor="#065F46"
                            />
                        </>
                    )}
                </PlatformStatsGrid>
            )}
            <GenerateTicketModal action={action} setAction={setAction} open={modals.generateTickets} handleClose={() => handleClose("generateTickets")} event={event} />
            <GenerateInvitationModal action={action} setAction={setAction} open={modals.generateInvitations} handleClose={() => handleClose("generateInvitations")} event={event} />
            <AddUsherModal action={action} setAction={setAction} open={modals.addUsher} handleClose={() => handleClose("addUsher")} event={event} />

            <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <Paper elevation={0} sx={{ ...platformPaperSx, height: '100%' }}>
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontFamily: platformFonts.display }}>
                                    Event details
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <LocationOn sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography color="text.secondary">{event?.location}</Typography>
                                </Box>
                                <Typography color="text.secondary">
                                    {moment(event?.date).format('DD/MM/yyyy @ HH:mm')}
                                </Typography>
                                <Typography sx={{ mt: 2 }}>{event?.description}</Typography>
                            </Box>

                            <Box sx={{ mb: 3 }}>
                                {((role === "Super" || role === "Admin") && (event?.corporate || true)) && (
                                    <PlatformActionSection title="Actions">
                                        <Box sx={actionButtonsWrapSx}>
                                            {role === "Super" && event?.corporate && (
                                                <PlatformButton variant="ghost" size="small" onClick={() => handleOpen("generateInvitations")}>
                                                    Generate Invitations
                                                </PlatformButton>
                                            )}
                                            {(role === "Super" || role === "Admin") && event?.corporate && (
                                                <PlatformButton variant="ghost" size="small" onClick={() => resendFailedInvitations({ eventId: id })}>
                                                    Resend Failed Invitations
                                                </PlatformButton>
                                            )}
                                            {role === "Super" && event?.whatsappReminderTemplate && (
                                                <PlatformButton
                                                    variant="ghost"
                                                    size="small"
                                                    onClick={() => sendEventReminder({ eventId: id })}
                                                    disabled={wait?.isLoading}
                                                >
                                                    {wait?.isLoading ? 'Sending…' : 'Send Reminder'}
                                                </PlatformButton>
                                            )}
                                            {(role === "Super" || event?.directInvitation) && (
                                                <PlatformButton variant="ghost" size="small" onClick={() => handleOpen("generateTickets")}>
                                                    {event?.directInvitation ? "Send tickets by email" : "Generate tickets"}
                                                </PlatformButton>
                                            )}
                                            {(role === "Super" || role === "Admin") && (
                                                <PlatformButton variant="ghost" size="small" onClick={() => navigate(`/event/edit/${id}`)}>
                                                    Edit Event
                                                </PlatformButton>
                                            )}
                                        </Box>
                                    </PlatformActionSection>
                                )}

                                <PlatformActionSection title="Views">
                                    <Box sx={actionButtonsWrapSx}>
                                        <PlatformButton variant="ghost" size="small" onClick={handleRefresh}>
                                            Refresh Info
                                        </PlatformButton>
                                        <PlatformButton variant="ghost" size="small" onClick={() => navigate(`/event/tickets/${id}`)}>
                                            View Tickets
                                        </PlatformButton>
                                        {event?.paymentMethod === "InstaPay" && (
                                            <PlatformButton variant="ghost" size="small" onClick={() => navigate(`/event/orders/requests/${id}`)}>
                                                View Order Requests
                                            </PlatformButton>
                                        )}
                                        {event?.corporate && (
                                            <PlatformButton variant="ghost" size="small" onClick={() => navigate(`/event/invitations/${id}`)}>
                                                View Invitations
                                            </PlatformButton>
                                        )}
                                        {event?.byRequest && (
                                            <PlatformButton variant="ghost" size="small" onClick={() => navigate(`/event/requests/${id}`)}>
                                                View Requests
                                            </PlatformButton>
                                        )}
                                        {event?.byRequest && (
                                            <PlatformButton variant="ghost" size="small" onClick={() => navigate(`/event/registration-page/${id}`)}>
                                                Registration Page
                                            </PlatformButton>
                                        )}
                                        <PlatformButton
                                            variant="ghost"
                                            size="small"
                                            disabled={moment().isBefore(event?.gatesOpenAt)}
                                            onClick={() => navigate(`/event/live/${id}`)}
                                        >
                                            View Live Statistics
                                        </PlatformButton>
                                        {(role === "Super" || role === "Admin") && (
                                            <PlatformButton
                                                variant="ghost"
                                                size="small"
                                                disabled={moment().isBefore(event?.gatesOpenAt) || wait?.isLoading}
                                                onClick={() => exportEventStatistics({ eventId: id })}
                                            >
                                                {wait?.isLoading ? 'Exporting…' : 'Export Statistics'}
                                            </PlatformButton>
                                        )}
                                    </Box>
                                </PlatformActionSection>

                                {role === "Super" && (
                                    <PlatformActionSection title="Danger zone">
                                        <Box sx={actionButtonsWrapSx}>
                                            <PlatformButton variant="danger" size="small" onClick={() => setDeleteModal(true)}>
                                                Delete Event
                                            </PlatformButton>
                                        </Box>
                                    </PlatformActionSection>
                                )}
                            </Box>

                            <ActionDialog
                                open={deleteModal}
                                handleAccept={() => deleteEvent({ eventId: id }, navigate)}
                                handleClose={() => setDeleteModal(false)}
                                title={`Are you sure you want to delete ${event?.title}?`}
                                content={"Deleting this event will delete all issued tickets and issue refunds to users as well as deleting all ushers and any trace of this event"}
                            />

                            <Box sx={{ mt: 4 }}>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Event Usher Gates
                                </Typography>
                                <Typography color="text.secondary" paragraph>
                                    Accounts for ushers to use. Give one account to each gate leader for all gate ushers to log in with
                                </Typography>

                                {ushers?.length > 0 && role === "Super" && (
                                    <PlatformButton variant="danger" size="small" onClick={() => handleDeleteUsher({ eventId: id })} sx={{ mb: 2 }}>
                                        Delete All Ushers
                                    </PlatformButton>
                                )}

                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    {ushers?.map((usher) => (
                                        <Paper
                                            key={usher._id}
                                            elevation={0}
                                            sx={{
                                                ...platformPaperSx,
                                                p: 2,
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    transform: 'translateY(-2px)',
                                                    boxShadow: '0 8px 40px rgba(70,16,155,0.14)',
                                                },
                                            }}
                                        >
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} sm={9}>
                                                    <Typography variant="h6" fontWeight="bold">
                                                        {usher.username}
                                                    </Typography>
                                                    <Typography color="text.secondary" sx={{ mt: 1 }}>
                                                        Assigned Gate: {usher.gate}
                                                    </Typography>
                                                    <Typography color="text.secondary">
                                                        Tickets Processed: {usher.ticketsProcessed}
                                                    </Typography>
                                                    <MainPassword
                                                        margin="normal"
                                                        fullWidth
                                                        name="password"
                                                        label="Password"
                                                        id="password"
                                                        readOnly
                                                        value={usher.password}
                                                        sx={{ mt: 1 }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' }, mt: { xs: 1, sm: 0 } }}>
                                                    <IconButton
                                                        onClick={() => handleDeleteUsher({ usherId: usher._id })}
                                                        sx={{
                                                            color: 'error.main',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(211, 47, 47, 0.04)'
                                                            }
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    ))}
                                </Box>

                                {role === "Super" && (
                                    <PlatformButton variant="ghost" size="small" onClick={() => handleOpen("addUsher")} sx={{ mt: 2 }}>
                                        Add Usher Gate
                                    </PlatformButton>
                                )}
                            </Box>
                        </Paper>
                    </motion.div>
                </Grid>

                <Grid item xs={12} md={8}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    >
                        <Paper elevation={0} sx={{ ...platformPaperSx, height: '100%' }}>
                            {event?.corporate && dashStats && (
                                <PlatformCard title="RSVP breakdown" sx={{ mb: 2.5, p: 2 }} contentSx={{ pt: 0 }}>
                                    <PlatformAnalyticBar label="Confirmed" percent={dashStats.sent ? (dashStats.accepted / dashStats.sent) * 100 : 0} value={String(dashStats.accepted)} color={platformColors.success} />
                                    <PlatformAnalyticBar label="Pending" percent={dashStats.sent ? (dashStats.pending / dashStats.sent) * 100 : 0} value={String(dashStats.pending)} color={platformColors.warn} />
                                    <PlatformAnalyticBar label="Declined" percent={dashStats.sent ? (dashStats.rejected / dashStats.sent) * 100 : 0} value={String(dashStats.rejected)} color={platformColors.danger} />
                                    <PlatformAnalyticBar label="Unsent inventory" percent={dashStats.inventory ? (dashStats.remaining / dashStats.inventory) * 100 : 0} value={String(dashStats.remaining)} color={platformColors.brand} />
                                </PlatformCard>
                            )}
                            {event?.corporate ? (
                                <Box>
                                    <PlatformTabs
                                        tabs={[
                                            { id: 0, label: 'Charts' },
                                            { id: 1, label: 'By category' },
                                        ]}
                                        value={statsTab}
                                        onChange={setStatsTab}
                                    />
                                    {statsTab === 1 && statistics && event?.categories?.map((category) => {
                                        const categoryStats = statistics?.[category.category] || {};
                                        const totalSent = (categoryStats.pendingInvitations || 0) + 
                                                         (categoryStats.acceptedInvitations || 0) + 
                                                         (categoryStats.rejectedInvitations || 0);
                                        const totalUpForSale = (categoryStats.remaining || 0) + 
                                                               (categoryStats.acceptedInvitations || 0) + 
                                                               (categoryStats.rejectedInvitations || 0) + 
                                                               (categoryStats.pendingInvitations || 0);
                                        
                                        return (
                                            <Box key={category.category} sx={{ mb: 4 }}>
                                                <Typography 
                                                    variant="h6" 
                                                    fontWeight="bold" 
                                                    gutterBottom 
                                                    sx={{ 
                                                        mb: 3,
                                                        color: 'var(--primaryPurple)',
                                                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                    }}
                                                >
                                                    {category.category}
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    {/* Total Up for Sale Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '2px solid var(--primaryPurple)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: 'var(--primaryPurple)'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: 'var(--primaryPurple)',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <EventAvailableIcon sx={{ color: 'white', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Total Up for Sale
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: 'var(--primaryPurple)',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {totalUpForSale}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                    {/* Sent Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '1px solid var(--platform-border)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: 'var(--primaryPurple)'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: '#e3f2fd',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <SendIcon sx={{ color: '#1976d2', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Sent
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: '#1976d2',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {totalSent}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                    {/* Remaining Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '1px solid var(--platform-border)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: 'var(--primaryPurple)'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: '#f3e5f5',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <InventoryIcon sx={{ color: 'var(--primaryPurple)', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Remaining
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: 'var(--primaryPurple)',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {categoryStats.remaining || 0}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                    {/* Pending Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '1px solid var(--platform-border)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: '#ff9800'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: '#fff3e0',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <PendingIcon sx={{ color: '#ff9800', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Pending
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: '#ff9800',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {categoryStats.pendingInvitations || 0}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                    {/* Accepted Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '1px solid var(--platform-border)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: '#2e7d32'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: '#e8f5e9',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <CheckCircleIcon sx={{ color: '#2e7d32', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Accepted
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: '#2e7d32',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {categoryStats.acceptedInvitations || 0}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                    {/* Rejected Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '1px solid var(--platform-border)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: '#d32f2f'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: '#ffebee',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <CancelIcon sx={{ color: '#d32f2f', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Rejected
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: '#d32f2f',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {categoryStats.rejectedInvitations || 0}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                </Grid>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            ) : (
                                <Box>
                                    <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3, fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif' }}>
                                        Category Statistics
                                    </Typography>
                                    {statistics && event?.categories?.map((category) => {
                                        const categoryStats = statistics?.[category.category] || {};
                                        const totalAvailable = (categoryStats.remaining || 0) + (categoryStats.sold || 0);
                                        
                                        return (
                                            <Box key={category.category} sx={{ mb: 4 }}>
                                                <Typography 
                                                    variant="h6" 
                                                    fontWeight="bold" 
                                                    gutterBottom 
                                                    sx={{ 
                                                        mb: 3,
                                                        color: 'var(--primaryPurple)',
                                                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                    }}
                                                >
                                                    {category.category}
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    {/* Total Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '2px solid var(--primaryPurple)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: 'var(--primaryPurple)'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: 'var(--primaryPurple)',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <EventAvailableIcon sx={{ color: 'white', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Total
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: 'var(--primaryPurple)',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {totalAvailable}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                    {/* Sold Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '1px solid var(--platform-border)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: '#2e7d32'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: '#e8f5e9',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <ShoppingCartIcon sx={{ color: '#2e7d32', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Sold
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: '#2e7d32',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {categoryStats.sold || 0}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                    {/* Remaining Card */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Card
                                                            elevation={0}
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'var(--platform-surface)',
                                                                border: '1px solid var(--platform-border)',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateY(-4px)',
                                                                    boxShadow: 4,
                                                                    borderColor: 'var(--primaryPurple)'
                                                                }
                                                            }}
                                                        >
                                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "flex-start", sm: "center" }}>
                                                                <Box
                                                                    sx={{
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: '#f3e5f5',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <InventoryIcon sx={{ color: 'var(--primaryPurple)', fontSize: 28 }} />
                                                                </Box>
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography 
                                                                        variant="overline" 
                                                                        sx={{ 
                                                                            color: 'var(--tickit-gray500)',
                                                                            fontSize: '0.75rem',
                                                                            fontWeight: 600,
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        Remaining
                                                                    </Typography>
                                                                    <Typography 
                                                                        variant="h4" 
                                                                        fontWeight={700}
                                                                        sx={{ 
                                                                            color: 'var(--primaryPurple)',
                                                                            fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                                                        }}
                                                                    >
                                                                        {categoryStats.remaining || 0}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Card>
                                                    </Grid>

                                                </Grid>
                                            </Box>
                                        );
                                    })}

                                    {/* Finance Charts */}
                                    {statsTab === 0 && statistics && <Box sx={{ mt: 1, mb: 4 }}>
                                        <Typography variant="h6" textAlign="center" gutterBottom sx={{ fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif' }}>
                                            Ticket Sales
                                        </Typography>
                                        <ResponsiveContainer width="100%" height={280}>
                                            <BarChart
                                                data={event?.categories?.map((cat) => ({
                                                    name: cat.category,
                                                    "Tickets Remaining": statistics?.[cat.category]?.remaining || 0,
                                                    "Tickets Sold": statistics?.[cat.category]?.sold || 0
                                                }))}
                                                margin={{ top: 5, right: 16, left: 8, bottom: 5 }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Bar dataKey="Tickets Remaining" fill="var(--secColor)" />
                                                <Bar dataKey="Tickets Sold" fill="var(--terColor)" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </Box>}

                                    {statsTab === 0 && statistics && <Box>
                                        <Typography variant="h6" textAlign="center" gutterBottom sx={{ fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif' }}>
                                            Income
                                        </Typography>
                                        <ResponsiveContainer width="100%" height={280}>
                                            <BarChart
                                                data={event?.categories?.map((cat) => ({
                                                    name: cat.category,
                                                    "Sales": (statistics?.[cat.category]?.sold || 0) * cat.price
                                                }))}
                                                margin={{ top: 5, right: 16, left: 8, bottom: 5 }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Bar dataKey="Sales" fill="var(--secColor)" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </Box>}
                                </Box>
                            )}
                        </Paper>
                    </motion.div>
                </Grid>
            </Grid>
        </PlatformPage>
    );
}

const mapStateToProps = (state) => ({
    wait: state?.wait,
    event: state?.events?.results,
    statistics: state?.records?.results?.statistics,
    ushers: state?.records?.results?.ushers?.docs,
    isLoading: state?.events?.isLoading,
    role: state?.auth?.token?.split(" ")[0]
});

const mapDispatchToProps = { getEvent, getUshers, deleteEvent, deleteUshers, getEventStatistics, resendFailedInvitations, sendEventReminder, exportEventStatistics };

export default connect(mapStateToProps, mapDispatchToProps)(EventDashboard);